<template>
    <v-dialog
        v-model="isDialogOpen"
        transition="dialog-bottom-transition"
        persistent
        fullscreen>

        <div class="container-form-stock">

          <v-btn
            class="btn-close-stock"
            color="#6E6E6E"
            variant="text"
            @click="isDialogOpen=false">
              <v-icon size="26">mdi-close</v-icon>
          </v-btn>

            <div class="form-stock">
              <span class="title-lbl-stock">
                {{isEdit ? 'Edición de almacén':'Registro de almacén'}}
              </span>

              <div class="form-row-stock">
                <v-select
                  style="max-width: 40%; margin-left: 70px;"
                  v-model="postSelected"
                  :items="filteredAndSortedTerminals"
                  item-title="label"
                  item-value="value"
                  density="compact"
                  label="Terminal de venta u operación"
                  hide-details="auto"
                  variant="underlined"
                  class="no-bg"
                  :disabled="isEdit"/>
                <v-radio-group class="radio-stock"
                  v-model="type" inline :disabled = isEdit>
                  <v-radio label="Entrada" value="in"
                  style="margin-right: 80px;"/>
                  <v-radio label="Salida" value="out"/>
                </v-radio-group>
              </div>
              <div v-if="!isEdit" class="form-row-stock">
                <div><span></span></div>
                <v-btn
                  color="#FF5700"
                  variant="text"
                  rounded="xl"
                  @click="addNewStock">
                  <div  class="form-row-stock">
                    <span style="color: #FF5700; font-weight: bold;">Agregar producto</span>
                  </div>
                </v-btn>
              </div>

              <div v-for="(item, index) in stock" :key="index"
                style="padding-top: 40px;">

                <div class="form-row-stock">
                  <v-btn
                    v-if="!isEdit"
                    color="red"
                    variant="text"
                    rounded="xl"
                    @click="deleteItem(item)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>

                  <v-autocomplete
                    :style="{
                      maxWidth: '30%',
                      marginLeft: isEdit ? '70px' : '0',
                      marginTop: '22px',
                      maxHeight: '10px'
                    }"
                    :items="sortedProducts"
                    :item-title="formatProduct"
                    label="Producto"
                    density="compact"
                    variant="underlined"
                    class="no-bg touch-scroll"
                    :disabled="isEdit"
                    hide-details="auto"
                    v-model="item.product_id"
                    item-value="_id"
                    @update:model-value="productId => onProductChange(productId, item)"
                  />

                  <v-text-field
                    style="max-width: 15%; margin-top: 22px;"
                    v-model.number="item.quantity"
                    label="Cantidad"
                    type="number"
                    density="compact"
                    variant="underlined"
                    class="no-bg"
                    :disabled = isEdit
                    @input="onChangeTotal(item)"/>

                  <v-text-field
                    style="max-width: 15%; margin-top: 22px;"
                    v-model.number="item.cost"
                    label="Costo Unitario"
                    type="number"
                    density="compact"
                    variant="underlined"
                    class="no-bg"
                    :disabled = isOut
                    @input="onChangeTotal(item)"/>

                  <v-text-field
                    style="max-width: 15%; margin-top: 22px;"
                    v-model="item.total"
                    label="Total"
                    density="compact"
                    variant="underlined"
                    class="no-bg"
                    disabled/>

                  <v-text-field
                    style="max-width: 15%; margin-top: 22px;"
                    v-model="item.prod_price"
                    label="Precio de Venta"
                    density="compact"
                    variant="underlined"
                    class="no-bg"/>

                </div>

                <v-textarea
                style="margin-left: 70px;"
                v-model="item.note"
                label="Nota"
                density="compact"
                variant="underlined"
                class="no-bg"
                rows="3"/>
              </div>

            </div>

            <div class="actions-form-stock">
                <v-btn
                class="btn-cancel-form"
                color="#6E6E6E"
                variant="text"
                rounded="xl"
                @click="isDialogOpen = false">
                    Cancelar
                </v-btn>

                <v-btn
                class="btn-action-form text-white"
                rounded="xl"
                @click="saveStock">
                    Guardar
                </v-btn>

            </div>
        </div>

    </v-dialog>
</template>

<script>
import catalogApi from '@/api/catalogApi'
import stockApi from '@/api/stockApi'
export default {
  name: 'CommerciaVueAddEditStock',
  props: ['terminals'],
  emits: ['refreshList'],
  data () {
    return {
      isDialogOpen: false,
      isEdit: false,
      validData: false,
      isSavingData: false,
      postSelected: '',
      productSelected: '',
      type: '',
      total: 0,
      products: [],
      stock: [],
      businessId: '',
      itemEmpty: {
        alias: '',
        edited_by: '',
        product_id: '',
        product_sku: '',
        product_name: '',
        terminal_id: '',
        business_id: '',
        type: '',
        cost: 0,
        quantity: 0,
        note: '',
        total: 0,
        prod_price: 0
      },
      rules: {
        required: [v => !!v || 'Campo requerido.']
      }
    }
  },
  watch: {
    postSelected (newValue, oldValue) {
      this.getProducts(newValue)
    }
  },
  computed: {
    isOut () {
      return this.type === 'out'
    },
    filteredAndSortedTerminals () {
      return this.terminals
        .filter(item => item.value !== 'all')
        .sort((a, b) => a.label.localeCompare(b.label))
    },
    sortedProducts () {
      return this.products.slice().sort((a, b) => {
        return a.sku.localeCompare(b.sku)
      })
    }
  },
  methods: {
    add () {
      this.isDialogOpen = true
      this.stock = []
      this.stock.push(JSON.parse(JSON.stringify(this.itemEmpty)))
    },
    edit (item) {
      this.isDialogOpen = true
      this.isEdit = true
      this.stock = []
      item.total = item.cost * item.quantity
      this.stock.push(JSON.parse(JSON.stringify(item)))
      this.postSelected = item.terminal._id
      this.productSelected = item.product_id
      this.type = item.type
      this.getProductPrice()
    },
    onClearFilter () {
      this.filterSelected = 'all'
    },
    addNewStock () {
      this.stock.push(JSON.parse(JSON.stringify(this.itemEmpty)))
    },
    deleteItem (item) {
      const index = this.stock.indexOf(item)
      if (index !== -1) {
        this.stock.splice(index, 1)
      }
    },
    formatProduct (product) {
      if (!product) return ''
      return `${product?.sku || ''} - ${product?.name || ''}`.trim()
    },
    onProductChange (productId, item) {
      const selectedProduct = this.products.find(p => p._id === productId)
      console.log(selectedProduct)
      if (selectedProduct) {
        item.product_name = selectedProduct.name
        item.product_sku = selectedProduct.sku
        item.prod_price = selectedProduct.price
        item.business_id = selectedProduct.business
        console.log(item)
      }
    },
    onChangeTotal (item) {
      const cost = parseFloat(item.cost) || 0
      const quantity = parseFloat(item.quantity) || 0
      item.total = cost * quantity
    },
    getProductPrice () {
      if (this.isEdit && this.stock.length > 0) {
        for (const item of this.products) {
          if (item._id === this.stock[0].product_id) {
            this.stock[0].prod_price = parseInt(item.prod_price)
          }
        }
      }
    },
    async getProducts (idPos) {
      const respose = await catalogApi.listAllByPos(idPos)
      console.log(respose.products)
      this.products = respose.products
    },
    async saveStock () {
      const timestamp = new Date().getTime()
      const userData = this.$store.state.user

      for (const [index, item] of this.stock.entries()) {
        item.alias = timestamp + '=' + index
        item.edited_by = userData._id
        item.type = this.type
        item.terminal_id = this.postSelected
        await stockApi.add(item)
      }

      this.isSavingData = false
      console.log('emit refreshList')
      this.$emit('refreshList')
      this.isDialogOpen = false
    }

  }
}
</script>

<style scoped>
  @import '@/assets/styles/stock.css';
  @import '@/assets/styles/inputs.css';

.touch-scroll .v-overlay__content {
  touch-action: pan-y !important;
  overscroll-behavior: contain;
}

.v-overlay__content {
  pointer-events: auto !important;
}
</style>
